// @ts-nocheck
import React, { createContext, useContext, useState } from "react";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [paginationData, setpaginationData] = useState({});

  return (
    <GlobalContext.Provider value={{ paginationData, setpaginationData }}>
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
